import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface DeactivateConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  entityType: 'offer' | 'campaign';
  entityLabel: string;
}

export default function DeactivateConfirmDialog({
  open,
  onClose,
  onConfirm,
  isPending,
  entityType,
  entityLabel,
}: DeactivateConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Deactivate {entityType === 'offer' ? 'Offer' : 'Campaign'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to deactivate &quot;{entityLabel}&quot;? This can be reversed by reactivating later.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm} disabled={isPending}>
          {isPending ? 'Deactivating...' : 'Deactivate'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
